<template>
    <div class="mt-3.5 lg:mt-0 font-bold flex items-center text-center text-14 lg:text-16">
        <div class="flex-1 flex items-center justify-center h-10" :class="[activeMenu == 'menu' ? activeStyle : inactiveStyle]" @click="onClickMenu('menu')">{{lbl.favorite.tab_menu}}</div>
        <div class="flex-1 flex items-center justify-center h-10" :class="[activeMenu == 'order' ? activeStyle : inactiveStyle]" @click="onClickMenu('order')">{{lbl.favorite.tab_order}}</div>
    </div>
</template>
<script>
// mixins
import LocaleMixin from '@/mixin/LocaleMixin';
export default {
    name: "TabMenu",
    mixins: [LocaleMixin],
    data: function() {
        return {
            activeMenu: 'menu', //menu, order
            activeStyle: 'border-b-4 border-a-red-d62300',
            inactiveStyle: 'border-b border-a-brown-d7c7b8',
        }
    },
    methods: {
        onClickMenu: function(menu){
            this.activeMenu = menu;
            this.$emit('updateActiveMenu', this.activeMenu)
        },
    },

}
</script>
<style lang="scss" scoped>
</style>
